import { call, put, select, takeLatest } from "redux-saga/effects";
import {
    FETCH_BUSINESS_CASE_REQUEST,
    fetchBusinessCaseFailure,
    fetchBusinessCaseSuccess
} from "../../actions/opportunities/businessCaseActions";
import iq_api_v2 from "../../../../services/iqApiV2";
import qs from 'qs';

async function findBusinessCaseData(opportunityId = "") {
    const data = qs.stringify({
      opportunity_id: opportunityId,
    });
  
    try {
      const response = await iq_api_v2.post("/opportunities/get_business_use_case?"+data, '')
    //   console.log('Response:', response.data);
      return response?.data
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  }

// Worker Saga
function* fetchBusinessCaseSaga() {
  try {
    const payload = yield select(
      (state) => state?.businessCaseReducer?.payload
    );
    const { opportunityId = "" } = payload;
    const data = yield call(
        findBusinessCaseData,
        opportunityId
    );
    yield put(fetchBusinessCaseSuccess(data));
  } catch (error) {
    yield put(fetchBusinessCaseFailure(error.message));
  }
}

// Watcher Saga
export function* watchBusinessCaseData() {
  yield takeLatest(FETCH_BUSINESS_CASE_REQUEST, fetchBusinessCaseSaga);
}